import React from 'react';
import {Grid, Typography} from '@deere/fuel-react';
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

export const SummaryGeneralComments = ({classes}) => {
    return <AccordionSummary
        className={classes.accordionSummary}
        classes={{
            expandIcon: classes.expandIcon,
            content: classes.content,
            expanded: classes.expanded
        }}
        expandIcon={<ExpandMoreIcon style={{fontSize: '2rem'}}/>}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
    >
        <Grid container>
            <Grid item xs={12}>
                <Typography color="primary" size="md">General Comments</Typography>
            </Grid>
        </Grid>
    </AccordionSummary>
}